// Renders a Playfair heading where words wrapped in *asterisks* become italic accent words.
// Example: <AccentHeading text="A Legacy of Trust & *Excellence*" />
export const AccentHeading = ({ text, className = "", as: Tag = "span" }) => {
  const parts = text.split(/(\*[^*]+\*)/g).filter(Boolean);
  return (
    <Tag className={`font-playfair ${className}`}>
      {parts.map((part, i) => {
        if (part.startsWith("*") && part.endsWith("*")) {
          return (
            <em key={i} className="accent-italic">
              {part.slice(1, -1)}
            </em>
          );
        }
        return <span key={i}>{part}</span>;
      })}
    </Tag>
  );
};
